
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft6 as ObiWindShaft6Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-6.js';
 
 
 

 
 export const ObiWindShaft6 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-6',
   elementClass: ObiWindShaft6Element,
   events: {
     
   }
  });
 
 